module.exports = __webpack_public_path__ + "static/media/logo.0bfe6e7c.jpg";